import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdUnit from '../components/AdUnit';
import AdRotator from '../components/AdRotator';
import './StaticPages.css';
import './ContactPage.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const CONTACT_SUBJECTS = [
  { value: "", label: "-- Select a subject --" },
  { value: "prediction_accuracy", label: "💡 Prediction Accuracy & Results" },
  { value: "new_features", label: "✨ Feature Requests & Suggestions" },
  { value: "privacy_data", label: "🔒 Privacy & Data Security" },
  { value: "account_billing", label: "💳 Account & Billing Support" },
  { value: "general_inquiry", label: "📧 General Inquiry" }
];

const ContactPage = () => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [token, setToken] = useState(null);
  
  // Form state
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    region: '',
    subject: '',
    message: ''
  });
  
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [useremail, setEmail] = useState('');



  useEffect(() => {
    // Check if user is logged in
    console.log("Client Contact Token: " + localStorage.getItem('token'));
    const userToken = localStorage.getItem('token');

    console.log("Client Contact Token: " + userToken);
    if (userToken) {
      setIsLoggedIn(true);
      setToken(userToken);

      try {
        const payload = JSON.parse(atob(userToken.split('.')[1]));
        setEmail(payload.email || '');
        console.log("contact email from token: " + useremail + " | "+ payload.email);
      } catch (err) {
        console.error('Error decoding token to get email:', err);
      }
    


    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/contact/submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess(true);
        setFormData({
          name: '',
          email: '',
          phone: '',
          region: '',
          subject: '',
          message: ''
        });
        
        // Scroll to top to show success message
        window.scrollTo({ top: 0, behavior: 'smooth' });
        
        // Hide success message after 5 seconds
        setTimeout(() => setSuccess(false), 5000);
      } else {
        setError(data.error || 'Failed to send message. Please try again.');
      }
    } catch (err) {
      setError('Network error. Please check your input (email) and try again.');
    } finally {
      setLoading(false);
    }
  };

  const offices = [
    {
      id: 1,
      region: "North America Office",
      address: "123 Silicon Valley Blvd, Suite 400",
      city: "San Francisco, CA 94105",
      country: "United States",
      phone: "+1 (415) 555-0123",
      mobile: "+1 (415) 555-0124",
      email: "contact.us@mellodai.com",
      mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d7148.016827274643!2d-122.40017149583082!3d37.5829778839757!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1sen!2str!4v1762322629551!5m2!1sen!2str"
    },
    {
      id: 2,
      region: "Asia office",
      address: "Internet City, Loft office 5, Office 202",
      city: "Dubai",
      country: "UAE",
      phone: "+971 502 136 511",
      mobile: "+971 502 12 6517",
      email: "contact.ae@mellodai.com",
      mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d8168.3831210625!2d55.15539617420745!3d25.096509193522177!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1sen!2str!4v1762322186120!5m2!1sen!2str"
    },
    {
      id: 3,
      region: "Europe Office",
      address: "Foley Street",
      city: "Dublin",
      country: "Ireland",
      phone: "+353 1 854 5524",
      mobile: "+353 85 812 4145",
      email: "contact.ir@mellodai.com",
      mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d9322.226294982154!2d-6.2397821618884155!3d53.34194651386128!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1sen!2str!4v1762322426487!5m2!1sen!2str"
    }
  ];

  return (
    <div className="static-page">
      <header className="static-header">
        <nav className="static-nav">
          <div className="logo" onClick={() => navigate('/')}>🔮 Mellodai</div>
          <a onClick={() => navigate('/')}>← Back to Home</a>
        </nav>
      </header>

      {/* Header Ad 
      <section className="headerAd">
        <AdUnit adSlot="8074484061" />
      </section>*/}

      <div className="contact-page-layout">
        {/* Left Sidebar Ad */}
        <aside className="contact-sidebar-ad">
          <div className="sticky-ad">
            <AdRotator floating={true} placement="sidebar" />
            {/*<AdUnit adSlot="5292408053" />*/}
          </div>
        </aside>

        {/* Main Content */}
        <div className="contact-main-content">
          <div className="hero" style={{padding: '80px 2rem 40px', marginTop: 0}}>
            <h1>📞 Contact Us</h1>
            <p>We're here to help. Reach out to our offices worldwide.</p>
          </div>

          {/* Success Message */}
          {success && (
            <div style={{
              background: 'rgba(34, 197, 94, 0.1)',
              border: '2px solid rgba(34, 197, 94, 0.3)',
              borderRadius: '12px',
              padding: '1.5rem',
              margin: '0 2rem 2rem',
              color: '#86efac'
            }}>
              <strong>✓ Message Sent Successfully!</strong>
              <p style={{margin: '0.5rem 0 0 0'}}>Thank you for contacting us. We'll respond within 24-48 hours.</p>
            </div>
          )}

          <div className="contact-intro">
            <p>Have questions about Mellodai? Need technical support or want to discuss enterprise solutions? Our team is ready to assist you across multiple regions.</p>
          </div>

          {/* Office Cards */}
          <div className="offices-container">
            {offices.map((office) => (
              <div key={office.id} className="office-card">
                <div className="office-header">
                  <h2>🌍 {office.region}</h2>
                </div>

                <div className="office-details">
                  <div className="office-info">
                    <div className="info-item">
                      <span className="info-icon">📍</span>
                      <div className="info-text">
                        <strong>Address:</strong>
                        <p>{office.address}</p>
                        <p>{office.city}</p>
                        <p>{office.country}</p>
                      </div>
                    </div>
{/*
                    <div className="info-item">
                      <span className="info-icon">☎️</span>
                      <div className="info-text">
                        <strong>Phone:</strong>
                        <p><a href={`tel:${office.phone.replace(/\s/g, '')}`}>{office.phone}</a></p>
                      </div>
                    </div>

                    <div className="info-item">
                      <span className="info-icon">📱</span>
                      <div className="info-text">
                        <strong>Mobile:</strong>
                        <p><a href={`tel:${office.mobile.replace(/\s/g, '')}`}>{office.mobile}</a></p>
                      </div>
                    </div>
*/}
                    <div className="info-item">
                      <span className="info-icon">✉️</span>
                      <div className="info-text">
                        <strong>Email:</strong>
                        <p><a href={`mailto:${office.email}`}>{office.email}</a></p>
                      </div>
                    </div>
                  </div>

                  <div className="office-map">
                    <iframe
                      src={office.mapUrl}
                      width="100%"
                      height="300"
                      style={{ border: 0, borderRadius: '12px' }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title={`${office.region} Location`}
                    ></iframe>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Contact Form Section */}
          <div className="content-section" style={{marginTop: '3rem'}}>
            <h2>💬 Send Us a Message</h2>
            
            {!isLoggedIn && (
              <div style={{
                background: 'rgba(239, 68, 68, 0.1)',
                border: '2px solid rgba(239, 68, 68, 0.3)',
                borderRadius: '12px',
                padding: '1.5rem',
                marginBottom: '2rem',
                textAlign: 'center'
              }}>
                <p style={{margin: '0 0 1rem 0', color: '#fca5a5', fontWeight: '600'}}>
                  🔒 Please log in to send us a message
                </p>
                <p style={{margin: '0', color: 'var(--textTertiary)'}}>
                  This helps us prevent spam and ensures we can respond to your inquiry properly.
                </p>
              </div>
            )}

            {isLoggedIn && (
              <p>Prefer to contact us online? Fill out the form below and we'll get back to you within 24 hours.</p>
            )}
            
            <form className="contact-form" onSubmit={handleSubmit}>
{/* 
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Name *</label>
                  <input 
                    type="text" 
                    id="name" 
                    name="name" 
                    value={formData.name}
                    onChange={handleInputChange}
                    required 
                    placeholder="Your full name"
                    disabled={!isLoggedIn}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Phone*</label>
                  <input 
                    type="tel" 
                    id="phone" 
                    name="phone" 
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="+1 (555) 123-4567"
                    disabled={!isLoggedIn}
                  />
                </div>
              </div>
*/}
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input 
                    type="email" 
                    id="email" 
                    name="email" 
                    value={useremail /*formData.email*/}
                    onChange={handleInputChange}
                    required 
                    placeholder="match your login email: your@email.com"
                    disabled={true/*!isLoggedIn*/}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="region">Region *</label>
                  <select 
                    id="region" 
                    name="region" 
                    value={formData.region}
                    onChange={handleInputChange}
                    required
                    disabled={!isLoggedIn}
                  >
                    <option value="">Select region</option>
                    <option value="north-america">North America</option>
                    <option value="asia-pacific">Asia Pacific</option>
                    <option value="europe">Europe</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <select
                  id="subject" 
                  name="subject" 
                  className="auth-input"
                  value={formData.subject}
                  onChange={handleInputChange}
                  required 
                  disabled={!isLoggedIn}
                >
                  {CONTACT_SUBJECTS.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message">
                  Message * 
                  <span style={{
                    float: 'right',
                    fontSize: '0.85rem',
                    color: formData.message.length >= 1000 ? '#ef4444' : formData.message.length >= 900 ? '#f59e0b' : '#a78bfa',
                    fontWeight: formData.message.length >= 900 ? '600' : 'normal'
                  }}>
                    {formData.message.length}/1000 characters
                  </span>
                </label>
                <textarea 
                  id="message" 
                  name="message" 
                  rows="6" 
                  value={formData.message}
                  onChange={handleInputChange}
                  maxLength={1000}
                  required 
                  placeholder="Tell us more about your inquiry..."
                  disabled={!isLoggedIn}
                ></textarea>
                {formData.message.length >= 900 && (
                  <div style={{
                    fontSize: '0.85rem',
                    color: formData.message.length >= 1000 ? '#ef4444' : '#f59e0b',
                    marginTop: '0.5rem'
                  }}>
                    {formData.message.length >= 1000 
                      ? '⚠️ Character limit reached' 
                      : `⚠️ ${1000 - formData.message.length} characters remaining`}
                  </div>
                )}
              </div>

              {error && (
                <div style={{
                  background: 'rgba(239, 68, 68, 0.1)',
                  border: '1px solid rgba(239, 68, 68, 0.3)',
                  borderRadius: '8px',
                  padding: '1rem',
                  marginBottom: '1rem',
                  color: '#fca5a5'
                }}>
                  ⚠️ {error}
                </div>
              )}

              {isLoggedIn ? (
                <button 
                  type="submit" 
                  className="btn-primary" 
                  style={{width: '100%'}}
                  disabled={loading}
                >
                  {loading ? 'Sending...' : 'Send Message'}
                </button>
              ) : (
                <button 
                  type="button"
                  className="btn-primary" 
                  style={{width: '100%'}}
                  onClick={() => navigate('/login')}
                >
                  Log In to Send Message
                </button>
              )}
            </form>
          </div>

          {/* Business Hours
          <div className="content-section">
            <h2>🕐 Business Hours</h2>
            <div className="business-hours-grid">
              <div className="hours-card">
                <h3>North America</h3>
                <p>Monday - Friday: 9:00 AM - 6:00 PM PST</p>
                <p>Saturday: 10:00 AM - 2:00 PM PST</p>
                <p>Sunday: Closed</p>
              </div>
              <div className="hours-card">
                <h3>Asia Pacific</h3>
                <p>Monday - Friday: 9:00 AM - 6:00 PM SGT</p>
                <p>Saturday: 10:00 AM - 2:00 PM SGT</p>
                <p>Sunday: Closed</p>
              </div>
              <div className="hours-card">
                <h3>Europe</h3>
                <p>Monday - Friday: 9:00 AM - 6:00 PM GMT</p>
                <p>Saturday: 10:00 AM - 2:00 PM GMT</p>
                <p>Sunday: Closed</p>
              </div>
            </div>
          </div>
          */}

          <div className="cta-section">
            <h2>Ready to Get Started?</h2>
            <p>Join thousands of users making informed decisions with AI-powered insights</p>
            <button className="btn-primary" onClick={() => navigate('/login')}>Try Mellodai Now</button>
          </div>
        </div>
      </div>

      {/* Bottom Ad */}
      <section style={{padding: '2rem', textAlign: 'center'}}>
        <AdUnit adSlot="8074484061" />
      </section>

      <footer className="static-footer">
        <p>&copy; 2025 Mellodai. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default ContactPage;
